<template>
  <div>
    <div class="col-md-12" style="padding-left: 5%; padding-right: 5%;">
      <div class="bg-plans-form mt-10">
        <h2>
          จัดการข้อมูลสัญญา
        </h2>
        <br />
        <b-button variant="success" @click="contractActionModal()">+ เพิ่มสัญญา</b-button>
        <table ref="table_1" id="table_1" class="display" style="width:100%">
        </table>

      </div>
    </div>
    <b-modal id="contractCreateForm" ref="contractActionModal" centered no-enforce-focus size="lg" title="เพิ่มบริษัท">
      <label class="mr-sm-2 mt-3">บริษัท</label>
      <b-form-select id="contractCreateForm_companyData" class="plans-form-select-lg custom-select2"
        v-model="contractCreateForm.companyData" :options="formSetting.companyData"></b-form-select>

      <label class="mr-sm-2 mt-3">มูลค่าสัญญา</label>
      <b-form-input v-model="contractCreateForm.priceOfContract" type="number" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">วันเริ่มสัญญา</label>
      <div>
        <date-picker v-model="contractCreateForm.startContract" type="date"></date-picker>
      </div>

      <label class="mr-sm-2 mt-3">วันสิ้นสุดสัญญา</label>
      <div>
        <date-picker v-model="contractCreateForm.endContract" type="date"></date-picker>
      </div>

      <label class="mr-sm-2 mt-3">อัพโหลดเอกสาร</label>
      <b-form-file v-model="contractCreateForm.contractFiles" class="mt-3" plain></b-form-file>

      <label class="mr-sm-2 mt-3">ระยะเวลาแจ้งเตือนสัญญาสิ้นสุด</label>
      <b-form-select id="contractCreateForm_alarmOfContract" class="plans-form-select-lg custom-select2"
        v-model="contractCreateForm.alarmOfContract" :options="formSetting.alarmOfContract"></b-form-select>

      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="confirmActioncontract()">
          ยืนยีน
        </b-button>
        <b-button variant="danger" @click="cancel()">
          ยกเลิก
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FetchService from "@/core/services/fetch.service";
import DataTable from 'datatables.net-bs4';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.css';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';
import $ from "jquery";
import moment from "moment";
import ThaiTambons from '@/assets/master_data/thai_geo_data/thai_tambons.json'
import ThaiAmphures from '@/assets/master_data/thai_geo_data/thai_amphures.json'
import ThaiProvinces from '@/assets/master_data/thai_geo_data/thai_provinces.json'
import Swal from 'sweetalert2'

export default {
  components: { DatePicker },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL || "http://localhost:3000",
      masterDataTable: {},
      dataTable: [],
      masterData: [],
      masterFormData: {
        companyData: []
      },
      contractCreateForm: {
        companyData: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        companyData: "",
        startContract: "",
        endContract: "",
        contractFiles: "",
        alarmOfContract: 1,
      },
      contractEditMode: 0,
      contractIdSelect: "",
      formSetting: {
        companyData: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        companyData: "",
        startContract: "",
        endContract: "",
        contractFiles: "",
        alarmOfContract: [
          {
            text: "1 เดือน",
            value: 1
          },
          {
            text: "2 เดือน",
            value: 2
          },
          {
            text: "3 เดือน",
            value: 3
          }
        ]
      },
    };
  },
  mounted() {
    this.getCompanyData()
    setTimeout(() => {
      this.getDataTable()
    }, 100)
  },
  methods: {
    getDataTable() {
      if (this.masterDataTable?.destroy) {
        this.masterDataTable.destroy()
      }

      FetchService.get("/getcontract", (response) => {
        if (response) {
          response = JSON.parse(response)
          this.masterData = response.allContract
          this.pageInit()
        }
      })
    },
    getCompanyData() {
      FetchService.get("/getcompany", (response) => {
        if (response) {
          response = JSON.parse(response)
          this.masterFormData.companyData = response.allCompany
          this.formSetting.companyData = response.allCompany.map(e => {
            return {
              value: e._id,
              text: e.name
            }
          })
        }
      })
    },
    pageInit() {

      let that = this
      console.log(this.masterData)
      let arrTable = this.masterData.map((row, index) => {
        let findCompany
        if (row?.buildingId) {
          findCompany = this.masterFormData.companyData.find(e => {
            return row.buildingId == e._id
          })
        }
        return [
          row?._id ? row._id : "",
          findCompany?.name ? findCompany.name : "",
          (row?.startContract && row?.endContract) ? `${moment(row.startContract).format("YYYY-MM-DD")} - ${moment(row.endContract).format("YYYY-MM-DD")}` : "",
          (row.upload.url.length > 0 && row.upload.fileNames.length > 0) ? `<a href="${this.baseUrl + row.upload.url[0]}" target="_blank">
            ${row.upload.fileNames[0].name}
          </a>` : "ไม่มีรูปภาพ หรือไฟล์",
          `<button type="button" class="btn btn-warning mr-4 btn-edit" style="cursor: pointer" value="${row?._id}">แก้ไข</button> <button type="button" class="btn btn-danger mr-4 btn-del" style="cursor: pointer" value="${row?._id}">ลบ</button>`,
        ]
      })

      this.masterDataTable = new DataTable('#table_1', {
        data: arrTable,
        columns: [
          { title: 'Id' },
          { title: 'ชื่อตึก' },
          { title: 'วันเริ่ม - สิ้นสุดสัญญา' },
          { title: 'รูปภาพ หรือ ไฟล์' },
          { title: 'ดำเนินการ' }
        ],
        dom: 'Bfrtip'
      });

      $('#table_1').on('click', '.btn-edit', (event) => {
        var data = event.currentTarget.value
        that.actionEditcontract(data)
      });

      $('#table_1').on('click', '.btn-del', (event) => {
        var data = event.currentTarget.value
        that.actionDelcontract(data)
      });

    },
    actionEditcontract(contractId) {
      this.contractActionModal()
      const rowData = this.findMasterDataById(contractId)

      // let findCompany
      // if (rowData?.company_id || rowData?.taxId) {
      //   findCompany = this.masterFormData.companyData.find(e => { return (rowData.company_id == e._id || rowData.company_id == e.name) || (rowData.taxId == e.taxId) })
      // }

      const my_moment = moment(rowData.alarmOfContract);
      const diff = moment(rowData.endContract).diff(my_moment,'months')

      this.contractCreateForm = {
        companyData: rowData.buildingId,
        priceOfContract: rowData.priceOfContract,
        startContract: new Date(rowData.startContract),
        endContract: new Date(rowData.endContract),
        // contractFiles: rowData.contractFiles,
        alarmOfContract: diff,
      }

      this.contractEditMode = 1
      this.contractIdSelect = contractId

    },
    actionDelcontract(contractId) {
      console.log("delcontract", contractId)
      this.contractIdSelect = contractId
      Swal.fire({
        title: 'ยืนยันการลบ ?',
        text: "คุณยืนยันการลบบริษัท ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delcontract()
        }
      })
    },
    findMasterDataById(id) {
      return this.masterData.find(e => {
        return e._id === id
      })
    },
    findMasterCompany(row) {
      let findCompany
      console.log(row)
      if (row?.company_id || row?.taxId) {
        findCompany = this.masterFormData.companyData.find(e => {
          return (row.company_id == e._id || row.company_id == e.name) || (e.taxId && row.taxId == e.taxId)
        })
      }
      return findCompany
    },
    contractActionModal() {
      this.clearForm()
      this.$refs["contractActionModal"].show();
      setTimeout(() => {
        $('.custom-select2').select2({
          theme: 'bootstrap4',
        });
      }, 100)
    },
    addcontract() {

      let buildingId = $('#contractCreateForm_companyData').val()
      let alarmOfContract = $('#contractCreateForm_alarmOfContract').val()

      let user_data = localStorage.getItem('user_data')
      user_data = JSON.parse(user_data)

      const formData = new FormData();
      formData.append('file_upload_contracts', this.contractCreateForm.contractFiles);  // เพิ่มไฟล์ที่ต้องการอัปโหลด
      formData.append('body', JSON.stringify({
        user: user_data,
        body: {
          buildingId: buildingId,
          priceOfContract: this.contractCreateForm.priceOfContract,
          startContract: moment(this.contractCreateForm.startContract).startOf('day'),
          endContract: moment(this.contractCreateForm.endContract).startOf('day'),
          alarmOfContract: moment(this.contractCreateForm.endContract).subtract(alarmOfContract, 'months'),
        },
      }));

      FetchService.post("/addcontract/", formData, res => {

        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.getCompanyData()
        this.$refs["contractActionModal"].hide()
      }, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })

    },
    editcontract() {
      let buildingId = $('#contractCreateForm_companyData').val()
      let alarmOfContract = $('#contractCreateForm_alarmOfContract').val()

      let user_data = localStorage.getItem('user_data')
      user_data = JSON.parse(user_data)

      const formData = new FormData();
      formData.append('file_upload_contracts', this.contractCreateForm.contractFiles);  // เพิ่มไฟล์ที่ต้องการอัปโหลด
      formData.append('body', JSON.stringify({
        user: user_data,
        body: {
          buildingId: buildingId,
          priceOfContract: this.contractCreateForm.priceOfContract,
          startContract: moment(this.contractCreateForm.startContract).startOf('day'),
          endContract: moment(this.contractCreateForm.endContract).startOf('day'),
          alarmOfContract: moment(this.contractCreateForm.endContract).subtract(alarmOfContract, 'months'),
        },
      }));

      FetchService.post(`/editcontract/${this.contractIdSelect}`, formData, res => {
        console.log(res)
        Swal.fire(
          'สำเร็จ',
          'แก้ไขข้อมูลแล้ว',
          'success'
        )

        this.getCompanyData()
        setTimeout(() => {
          this.getDataTable()
        }, 100)
        this.$refs["contractActionModal"].hide()
      },{
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
    },
    delcontract() {
      FetchService.get(`/deletecontract/${this.contractIdSelect}`, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'ลบข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.getCompanyData()
        this.$refs["contractActionModal"].hide()
      })
    },
    clearForm() {
      this.contractCreateForm = {
        companyData: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        companyData: "",
        startContract: "",
        endContract: "",
        contarctFile: "",
        alarmOfContract: 1,
      }
      this.contractEditMode = 0
    },
    confirmActioncontract() {

      const buildingId = $('#contractCreateForm_companyData').val()

      if (!buildingId && this.contractEditMode === 0) {
        Swal.fire(
          'มีข้อผิดพลาด',
          'กรุณาระบุชื่อบริษัท',
          'error'
        )
      } else {
        if (this.contractEditMode === 1) {
          Swal.fire({
            title: 'ยืนยันการแก้ไข ?',
            text: "คุณยืนยันการแก้ไขบริษัท ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.editcontract()
            }
          })
        } else {
          Swal.fire({
            title: 'ยืนยันการบันทึก ?',
            text: "คุณยืนยันการบันทึกบริษัท ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.addcontract()
            }
          })
        }
      }
    }
  }
};

</script>

<style>
.bg-plans-form {
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  font-size: 1rem;
  font-weight: 500;
}

input,
label {
  margin: 0.5rem 0;
}

#table_1 table {
  border-collapse: separate;
  border-spacing: 0;
}

#table_1 th {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

.dataTables_wrapper .dataTable thead th {
  border-top: solid 1px #DEDFE0;
  background-color: #f9fafb;
}


#table_1 thead tr:first-child th:first-child {
  border-top-left-radius: 10px;
}

#table_1 thead tr:first-child th:last-child {
  border-top-right-radius: 10px;
}

#table_1 thead tr:first-child th {
  border-top-style: solid;
}

#table_1 thead tr th:first-child {
  border-left-style: solid;
}

#table_1 td {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

#table_1 tbody th {
  border-style: none solid solid solid;
}

#table_1 tbody tr:first-child td:first-child {
  /* border-top-left-radius: 10px; */
}

#table_1 tbody tr:first-child td:last-child {
  /* border-top-right-radius: 10px; */
}

#table_1 tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

#table_1 tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

#table_1 tbody tr:first-child td {
  border-top-style: solid;
}

#table_1 tbody tr td:first-child {
  border-left-style: solid;
}

#table_1 tbody tr:first-child td:first-child.dataTables_empty {
  border-top-left-radius: 0px;
}

#table_1 tbody tr:first-child td:last-child.dataTables_empty {
  border-top-right-radius: 0px;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before {
  content: "" !important;
}

table.dataTable thead .sorting:after {
  content: "" !important;
}

table.dataTable thead .sorting_asc:after {
  content: "▲" !important;
  content: "▲" /"" !important;
}

table.dataTable thead .sorting_desc:after {
  content: "▼" !important;
  content: "▼" /"" !important;
}

table.dataTable tr.dtrg-group th {
  background-color: #f2f2f2;
  text-align: left;
}

#table_1 tbody tr:hover {
  background-color: #f5f5f5;
  /* สีที่คุณต้องการเมื่อ hover */
  cursor: pointer;
}

.dt-search {
  text-align: right;
  padding-bottom: 0.85rem;
}

.dt-search {
  text-align: right;
}
</style>